<template>
  <div class="content-wrapper">
    <div class="content-left">
      <div class="left-container">
        <router-view></router-view>
      </div>
    </div>
    <div class="content-right">
      <div class="right-container">
        <author-contact-us></author-contact-us>
      </div>
    </div>
  </div>
</template>

<script>
import AuthorContactUs from '@/components/AuthorContactUs/AuthorContactUs.vue'

export default {
  name: 'AuthorJinNangLevelOneContainer',
  components: { AuthorContactUs },
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {}
}
</script>

<style scoped>
.content-wrapper {
  width: 1200px;
  margin: auto;
  display: flex;
}
.content-left {
  flex: auto;

  margin-right: 20px;
}
.content-right {
  flex: none;
  width: 314px;
}
.left-container,
.right-container {
  border-radius: 5px;
  background-color: #ffffff;
}
</style>
